import { render, staticRenderFns } from "./ProductBrands.vue?vue&type=template&id=21c78d0b&"
import script from "./ProductBrands.vue?vue&type=script&lang=ts&"
export * from "./ProductBrands.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports